<template>
  <div>
    <audio src="/audio/headshot.mp3" ref="headshot" preload />
    <audio src="/audio/worms-hallelujah.mp3" ref="hallelujah" preload />
  </div>
</template>

<script>
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import { mapActions, mapGetters } from "vuex";
import { actions, getters } from "@/store";
import { CLOSE_REASON } from "@/constants";
import { randomInt } from "@/utils/randomInt";
import { ROUTE_NAMES } from "@/router/constants";

const IDLE_DISCONNECT = 120000; // 2 minutes
const IDLE_DISCONNECT_NOTIFY = IDLE_DISCONNECT - 20000; // 20 seconds before idle disconnect

export default {
  data() {
    return {
      activityEvents: ["mousemove", "click", "touchmove", "keydown"],
      notificationWorkWillStop: {
        id: "idle-work-stop",
        title: "Idling detected",
        message:
          "You will be disconnected from work if no activity in identification page will be detected",
        duration: IDLE_DISCONNECT - IDLE_DISCONNECT_NOTIFY,
        actions: [{ label: "Dismiss" }]
      },
      notificationWorkStopped: {
        id: "idle-work-stopped",
        title: "Your work had been stopped",
        message: `Your work has been stopped after not showing activity in identifications page for ${
          IDLE_DISCONNECT / 1000
        } seconds.`,
        duration: 0,
        actions: [{ label: "Dismiss" }]
      },
      idleTimeoutNotify: debounce(() => {
        this.notificationAdd(this.notificationWorkWillStop);
      }, IDLE_DISCONNECT_NOTIFY),
      idleTimeout: debounce(() => {
        this.workStop(CLOSE_REASON.IDLE_TIMEOUT);
        this.playRandomSound();
        this.notificationAdd(this.notificationWorkStopped);
      }, IDLE_DISCONNECT),
      resetIdleTimeout: throttle(() => {
        if (this.isWorking && this.hasPendingIdentification) {
          this.idleTimeoutNotify();
          this.idleTimeout();
          this.notificationDismiss(this.notificationWorkStopped);
        }
      }, 500)
    };
  },
  computed: {
    ...mapGetters([getters.currentIdentification, getters.isWorking]),
    hasPendingIdentification() {
      return !!this.currentIdentification?.identificationId;
    },
    isIdentificationRoute() {
      return this.$route.matched.some(
        ({ name }) => name === ROUTE_NAMES.IDENTIFICATION
      );
    }
  },
  mounted() {
    this.activityEvents.forEach(type => {
      document.addEventListener(type, this.handleActivity);
    });
  },
  beforeDestroy() {
    this.clearIdleTimeout();
    this.activityEvents.forEach(type => {
      document.removeEventListener(type, this.handleActivity);
    });
  },
  methods: {
    ...mapActions([
      actions.notificationAdd,
      actions.notificationDismiss,
      actions.workStop
    ]),
    playRandomSound() {
      const audios = ["headshot", "hallelujah"];
      const randomAudio = audios[randomInt(0, audios.length - 1)];
      this.$refs[randomAudio].volume = 0.2;
      this.$refs[randomAudio].play();
    },
    clearIdleTimeout() {
      this.resetIdleTimeout.cancel();
      this.idleTimeoutNotify.cancel();
      this.idleTimeout.cancel();
    },
    handleActivity() {
      if (this.isIdentificationRoute) {
        this.resetIdleTimeout();
      }
    }
  },
  watch: {
    hasPendingIdentification() {
      if (this.hasPendingIdentification) {
        this.resetIdleTimeout();
      } else {
        this.clearIdleTimeout();
      }
    },
    isIdentificationRoute() {
      if (this.isIdentificationRoute) {
        this.resetIdleTimeout();
      }
    },
    isWorking() {
      if (!this.isWorking) {
        this.clearIdleTimeout();
      }
    }
  }
};
</script>
